
export const buttons = {
  submit: 'Enviar',
  cancel: 'Cancelar',
  continue: 'Continuar',
  back: 'Atrás',
  next: 'Siguiente',
  finish: 'Finalizar',
  save: 'Guardar',
  edit: 'Editar',
  delete: 'Eliminar',
  confirm: 'Confirmar',
  close: 'Cerrar',
  retry: 'Reintentar',
  loading: 'Cargando...',
  cognitiveAssessment: 'Comenzar Evaluación Cognitiva',
  behavioralAssessment: 'Comenzar Evaluación Conductual',
  downloadPDF: 'Descargar PDF',
  print: 'Imprimir',
  share: 'Compartir',
  startAssessment: 'Comenzar Evaluación',
  completeAssessment: 'Completar Evaluación',
  retakeAssessment: 'Repetir Evaluación',
  viewResults: 'Ver Resultados',
  backToHome: 'Volver al Inicio'
};

export const language = {
  select: 'Seleccionar Idioma',
  english: 'Inglés',
  portuguese: 'Portugués',
  spanish: 'Español'
};

export const userForm = {
  title: 'Completar Tu Perfil',
  subtitle: 'Por favor proporciona tu información para recibir tus resultados personalizados',
  fullName: 'Nombre Completo',
  fullNamePlaceholder: 'Ingresa tu nombre completo',
  email: 'Dirección de Email',
  emailPlaceholder: 'Ingresa tu dirección de email',
  language: 'Idioma Preferido',
  continue: 'Continuar a Resultados',
  required: 'Campo requerido'
};

export const errors = {
  generic: 'Algo salió mal. Por favor intenta de nuevo.',
  network: 'Error de conexión. Verifica tu conexión a internet.',
  validation: 'Por favor verifica tu entrada e intenta de nuevo.',
  unauthorized: 'Debes iniciar sesión para continuar.',
  notFound: 'Recurso no encontrado.',
  serverError: 'Error del servidor. Por favor intenta más tarde.',
  loadingFailed: 'Error al cargar datos. Por favor intenta de nuevo.',
  saveFailed: 'Error al guardar. Por favor intenta de nuevo.',
  deleteFailed: 'Error al eliminar. Por favor intenta de nuevo.',
  assessmentError: 'Error de evaluación. Por favor intenta de nuevo.',
  translationMissing: 'Traducción faltante',
  invalidData: 'Datos inválidos proporcionados',
  sessionExpired: 'Tu sesión ha expirado. Por favor inicia sesión de nuevo.'
};

export const common = {
  loading: 'Cargando...',
  saving: 'Guardando...',
  success: '¡Éxito!',
  error: 'Error',
  warning: 'Advertencia',
  info: 'Información',
  yes: 'Sí',
  no: 'No',
  ok: 'OK',
  or: 'o',
  and: 'y',
  of: 'de',
  to: 'a',
  from: 'desde',
  in: 'en',
  at: 'en',
  on: 'en',
  with: 'con',
  without: 'sin',
  page: 'Página',
  total: 'Total',
  count: 'Cantidad',
  date: 'Fecha',
  time: 'Hora',
  name: 'Nombre',
  description: 'Descripción',
  status: 'Estado',
  type: 'Tipo',
  category: 'Categoría',
  priority: 'Prioridad',
  search: 'Buscar',
  filter: 'Filtrar',
  sort: 'Ordenar',
  export: 'Exportar',
  import: 'Importar',
  copy: 'Copiar',
  paste: 'Pegar',
  cut: 'Cortar',
  undo: 'Deshacer',
  redo: 'Rehacer',
  refresh: 'Actualizar',
  reset: 'Restablecer',
  clear: 'Limpiar',
  select: 'Seleccionar',
  selectAll: 'Seleccionar Todo',
  none: 'Ninguno',
  all: 'Todo',
  more: 'Más',
  less: 'Menos',
  show: 'Mostrar',
  hide: 'Ocultar',
  expand: 'Expandir',
  collapse: 'Contraer',
  open: 'Abrir',
  close: 'Cerrar',
  min: 'Mín',
  max: 'Máx',
  avg: 'Prom',
  today: 'Hoy',
  yesterday: 'Ayer',
  tomorrow: 'Mañana',
  week: 'Semana',
  month: 'Mes',
  year: 'Año',
  hour: 'Hora',
  minute: 'Minuto',
  second: 'Segundo',
  am: 'AM',
  pm: 'PM',
  learnMore: 'Saber más',
  switch: 'Cambiar',
  completedOn: 'Completado el',
  model: 'Modelo'
};
